export default __webpack_public_path__ + "static/media/s4img5.72479a70.webp";